import api from './';

export default {
  fetchAll: () => api.get('specialties?_count=9999').json().then(response => response.data),
}
